import React from 'react'

import {Badge} from 'antd'

import {FormattedRelative, intlShape} from 'react-intl'

const ConnectionState = ({device}, {intl}) => {
   let meta = device.meta || {}

   if (!meta['chan/connected']) {
      return <Badge status="error" text="Never Connected" />
   }

   if (meta['chan/connected'] && !meta['chan/disconnected']) {
      return (
         <Badge
            status="success"
            text={'Connected ' + intl.formatRelative(meta['chan/connected'])}
         />
      )
   } else if (meta['chan/connected'] > meta['chan/disconnected']) {
      return (
         <Badge
            status="success"
            text={'Connected ' + intl.formatRelative(meta['chan/connected'])}
         />
      )
   } else {
      return (
         <Badge status="error" text={'Disconnect ' + intl.formatRelative(meta['chan/connected'])} />
      )
   }
}

ConnectionState.propTypes = {
   device: React.PropTypes.object.isRequired
}

ConnectionState.contextTypes = {
   intl: intlShape
}

export const Info = ({device}) => {
   let proto = device['proto/tm'] || {},
      meta = device.meta || {}

   return (
      <div>
         <dl className="dl-horizontal dl-form">
            <dt>Part Number</dt>
            <dd>{proto.part || 'Unknown'}</dd>

            <dt>Firmware Rev.</dt>
            <dd>{proto.firmware || 'Unknown'}</dd>

            <dt>Hardware Rev.</dt>
            <dd>{proto.hardware || 'Unknown'}</dd>

            <dt>Last Event</dt>
            <dd>
               {meta['event/date'] ? <FormattedRelative value={meta['event/date']} /> : 'Never'}
            </dd>

            <dt>Last Command</dt>
            <dd>
               {meta['command/date'] ? <FormattedRelative value={meta['command/date']} /> : 'Never'}
            </dd>

            {'gateway' === device.type && <dt>Connection State</dt>}
            {'gateway' === device.type &&
               <dd>
                  <ConnectionState device={device} />
               </dd>}

         </dl>
      </div>
   )
}

Info.propTypes = {
   device: React.PropTypes.object
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/overview/Info.jsx